import React, {useState, useEffect} from 'react';
import moment                       from "moment";
import loadable                     from '@loadable/component';
import axios                        from 'axios';

/* Styles */
//import styles from './Onboarding.module.css';

/* Helpers */
import {phoneValidation, emailValidation, curpValida, phoneValidationLng}                                                                    from "../../helpers/data-format";
import {consultInformationC, sendCURP, getUID,calculateActos, getFiles, consultPersonalInf, consultByCodePostal, consultStates}              from "../../helpers/queries";
import {saveDocumentsClient, saveDataGeneral, saveDataDomicilio, saveCurp }                                                                  from "../../helpers/mutations_2";
import {retrieveClave, storeClave}                                                                                                           from "../../helpers/storage";
import {getSelfInfoDocuments}                                                                                                                from '../../helpers/axiosSelfieDocs';
import {getSelfInfoDocumentsCurp}                                                                                                            from '../../helpers/axiosDocsCurp';
import {getUpInfoDocuments}                                                                                                                  from '../../helpers/axiosConsultDocument';
import {getInfomationOnboarding}                                                                                                             from '../../helpers/consultInformations';
import {saveModelContact}                                                                                                                    from '../../helpers/saveContact';
import {getBase64FromUrl, imageToFile}                                                                                                       from "../../helpers/functions";

/* Wrapper */
import WrapperConsumer from '../../store';

/* Constants */
import {OCR_CURP, BASE_URL_SERVER, NUM_VIEW_ANDROID} from "../../constants";

/* Components */
const Documents      = loadable(() => import('../../Containers/documents'));
const NotaDocument   = loadable(() => import('../../Containers/documents/notaDocument'));
const PhotoMovil     = loadable(() => import('../../Containers/documents/photoMovil'));
const LoadDocument   = loadable(() => import('../../Containers/documents/loadDocument'));
const LoadMovil      = loadable(() => import('../../Containers/documents/loadMovil'));
const MSJSucess      = loadable(() => import('../../Containers/documents/successDocument'));
const General        = loadable(() => import('../../Containers/general'));
const IMGDoc         = loadable(() => import('../../Containers/comprobante'));
const Domicilio      = loadable(() => import('../../Containers/adress'));
const Contact        = loadable(() => import('../../Containers/contact'));
const OTPView        = loadable(() => import('../../Containers/otp'));
const FinishS        = loadable(() => import('../../Containers/sendSucces'));
const Selfie         = loadable(() => import('../../Containers/selfie'));
const Recomendations = loadable(() => import('../../Components/Recomendations'));
const LoadWindow     = loadable(() => import('../../Components/WindowLoadMovil'));
const LoadMessages   = loadable(() => import('../../Components/WindowMsj'));
const LoadWindowMsg  = loadable(() => import('../../Components/windowMessage'));

const Onboarding = (props) => {
    const {
      context: { 
            conApollo,
            language,
            errors, 
            setErrors, 
            setModal, 
            processOnboarding, 
            setProcessOnboarding,
            progressoRegister, 
            setProgressoRegister,
            progressoCounter,  
            setProgressoCounter,
            loadWindowS, 
            setLoadWindowS,
            seeCURP, 
            setSeeCURP,
            showIMGCURP, 
            setShowIMGCURP,
            activeCam, 
            setActiveCam,
            setTypeViewMovil,
            btnBack, 
            setBtnBack,
            setViewRecomendation,
            isEditingView,
            setIsEditingView,
            isEditingPhotos, 
            setIsEditingPhotos,
            isBackView, 
            setIsBackView,
            opColonias, 
            setOpColonias
        },
    } = props;

    const { typeView } = props.match.params;
    const params       = typeView.split("&");

    const url_server   = props.location.pathname.split("&");
    const query_params = props.location.search.split("&");
    const id_employe   = query_params[0]  ? query_params[0].replace("?asesor=", "") : 0;
    const id_credito   = query_params[1]  ? query_params[1].replace("credito=", "") : 0;
    const id_view      = query_params[2]  ? query_params[2].replace("view=", "")    : '';
    
    const [launchServe, setLaunchServe]         = useState(false);
    const [errorServices, setErrorServices ]    = useState({
        ife:         false,
        comprobante: false
    });
    const [uiidState,      setUiidState ]         = useState(null);
    const [asesoridState,  setAsesoridState ]     = useState(null);
    const [creditoidState, setCreditoidState ]    = useState(null);
    const [itSameDocument, setItSameDocument ]    = useState(false);

    const [typeDocument, setTypeDocument ]          = useState('');
    const [catalogStates, setCatalogStates]         = useState([]);
    const [isEditable, setIsEditable]               = useState({
        adress:             false,
        street:             false,
        exterior:           false,
        interior:           false,
        codepostal:         false,
        colonia:            false,
        municipio:          false,
        estado:             true,
        country:            false,
    });
    const [inftProspect, setInftProspect]           = useState({
        curp:               '-',
        curpextra:          '-',
        name:               '-',
        firstname:          '-',
        isfirstname:        false,
        secondname:         '-',
        issecondname:       false,
        namecomplete:       '-',
        datebirday:         '-',
        sexo:               'M',
        maritalstatus:      'soltero',
        rfc:                '-',
        numeroine:          '-',
        claveelector:       '-',
        municipyBirday:     '-',
        stateBirday:        '-',
        countryBirday:      '-',
        nacionalityBidray:  'Mexicana',
        isIFEAdress:        false,
        calleine:           '-',
        coloniaine:         '-',
        ciudadine:          '-',
        street1:            '-',
        exterior1:          '-',
        interior1:          '-',
        codepostal1:        '-',
        colonia1:           '-',
        municipio1:         '-',
        estado1:            '-',
        country1:           '-',
        adress:             '-',
        street:             '-',
        exterior:           '-',
        interior:           '-',
        codepostal:         '-',
        colonia:            '-',
        municipio:          '-',
        estado:             '-',
        country:            '-',
        cellphone:          '',
        phonehome:          '',
        phonerecards:       '',
        email:              ''
    });

    const [codeOTP, setCodeOTP] = useState({
        numberCode:   "",
        validateCode: false
    });

    const [documentsProspect, setDocumentsProspect] = useState({
        ifefrente:       '',
        ifefrenteup:     '',
        ifedetras:       '',
        ifedetrasup:     '',
        selfiebase64:    '',
        selfiebase64up:  '',
        curpbase64:      '',
        curpbase64up:    '',
        comprobbase64:   '',
        comprobbase64up: '',
        selfiefile:      '',
        ifefrontalfile:  '',
        ifedetrasfile:   '',
        curpbasfile:     '',
        comprobfile:     ''
    });

    /// Data General
    const [messageIne, setMessageIne ]     = useState('');
    const [messageSelfie, setMessageSelfie] = useState("");
    const [dataVigence, setDataVigence ] = useState(true);

    const windowLoad = (textoLoad) => {
        setModal({
            showModal: true,
            closeModal: () =>
              setModal((prevState) => {
                return { ...prevState, showModal: false }
              }),
            component: (
              <LoadWindow textLoad={textoLoad}  />
            ),
            customCss: 'lodWindow',
            size: 'sm',
            backdrop: 'static',
        });
    }

    const windoMessage = (msj) => {
        setModal({
            showModal: true,
            closeModal: () =>
              setModal((prevState) => {
                return { ...prevState, showModal: false }
              }),
            component: (
              <LoadMessages textLoad={msj} setModal={setModal} />
            ),
            customCss: 'lodWindow',
            size: 'sm',
            backdrop: "static",
        });
    }

    const windowMessageAlert = (msj, textBtnSuccess, textBtnFaild, params) => {
        setModal({
            showModal: true,
            closeModal: () =>
              setModal((prevState) => {
                return { ...prevState, showModal: false }
              }),
            component: (
              <LoadWindowMsg textLoad={msj} textBtnSuccess={textBtnSuccess} textBtnFaild={textBtnFaild} stateContinue={params} setModal={setModal} />
            ),
            customCss: 'lodWindow',
            size: 'sm',
            backdrop: "static",
        });
    }

    const closeModal = () => {
        setModal((prevState) => {
            return { ...prevState, showModal: false }
        });
    } 
    
    const consultUiid = () => {
        
        getUID("AgregarCliente").then(function (response) {
            if(response === "error"){
                storeClave("sin");
                setUiidState("sin");
            }else{
                setUiidState(response);
                storeClave(response);
            }
        });
    } 

    const getCalculateCredit = async (uiidp, creditid, view) => {
        
        windowLoad("Obteniendo información....");
        if(view === ""){
            setProcessOnboarding("documents");
        }else{
            setProcessOnboarding(view);
        }
        
        getInfomationOnboarding(uiidp, view, creditid, setUiidState, closeModal, windoMessage, documentsProspect, setDocumentsProspect, inftProspect, setInftProspect, setOpColonias, windowLoad);

    }

    const getCalculateAct = async (uiidp) => {

        windowLoad("Retomando proceso...");

        calculateActos(String(uiidp)).then(function (response) {
            closeModal();
            if(response.code == 200){

                var typeView = "documents";

                if(response.response.actIneReverse === false && response.response.actIneObverse === false ){
                    typeView = "documents";
                }else if(response.response.actSelfie === false){
                    typeView = "selfie";
                    setBtnBack(true);
                }else if(response.response.actGeneralData === false){
                    typeView = "general";
                    setBtnBack(true);
                }else if(response.response.actAdress === false){
                    typeView = "imgdoc";
                    setBtnBack(true);
                }else if(response.response.actContact === false){
                    typeView = "contact";
                    setBtnBack(true);
                }else{
                    typeView = "documents";
                }

                consultFilesUp(uiidp, id_credito, typeView);

            }else{
                setProcessOnboarding("documents");
            }
            
        });
    }

    const getCalculateEdit = async (uiidp) => {
        
        windowLoad("Obteniendo información....");
        setProcessOnboarding("documents");
        consultDocuments(uiidp);

    }

    const getInformationCURP = async (uuidp) => {

        let dataCurp = {
            "curp": documentsProspect.curpbase64.slice(
                documentsProspect.curpbase64.indexOf("base64") + 7,
                documentsProspect.curpbase64.length
              )
        }

        windowLoad("Estamos enviando tu información....");

        try {
            const response = await axios({
              url:    OCR_CURP,
              method: 'POST',
              data:   dataCurp
            });


            if(response.status === 200){
                
                var curpError = response.data.curp;

                if(curpError.length < 1){
                    closeModal();
                    setMessageIne('errorOCRCURP');
                }else{

                    var respCurp = curpValida(response.data.curp[0]);
                    if(respCurp === false){
                        closeModal();
                        setMessageIne('badCurp');

                        errors['CURP']  = 'badCurp';

                        setErrors((prevState) => {
                            return { ...prevState, ...errors }
                        });
                    }else{

                        getCURP(response.data.curp[0], uuidp) 

                    }
                }

                inftProspect['curpextra'] = curpError.length > 0 ?  response.data.curp[0] : '';

                setInftProspect((prev) => {
                    return { ...prev, ...inftProspect }
                });
      
            }
      
          } catch (error) {
            closeModal();
            setMessageIne('errorOCRCURP');

          }
    }

    const getCURP = async (curp, uuidp) => {

        windowLoad("Estamos por terminar...");

        sendCURP(curp).then(function (respoService) {

            closeModal();
            
            if(respoService.curp === null){
                errors['CURP']  = 'badCurp';

                setMessageIne('CURPINCORRECTO');
                setShowIMGCURP(false);

            }else if(respoService.nombre != inftProspect.name){
                setMessageIne('PersonNotSame');
                setShowIMGCURP(false);
            }else{

                errors['CURP']  = '';
                saveCurp(respoService.curp, uuidp).then(function (respCURP) {
                    if(respCURP.code === 404 || respCURP.code === 200 ){

                        setMessageIne('CURPCorrecto');

                        inftProspect['curp']              =  respoService.curp;
                        inftProspect['curpextra']         =  respoService.curp;
                        inftProspect['name']              =  respoService.nombre;
                        inftProspect['firstname']         =  respoService.apellidoPaterno != null  || respoService.apellidoPaterno != "null" ? respoService.apellidoPaterno : "";
                        inftProspect['isfirstname']       =  respoService.apellidoPaterno === null || respoService.apellidoPaterno === '' ? true : false;
                        inftProspect['secondname']        =  respoService.apellidoMaterno != null  || respoService.apellidoMaterno != "null" ? respoService.apellidoMaterno : "";
                        inftProspect['issecondname']      =  respoService.apellidoMaterno === null || respoService.apellidoMaterno === '' ? true : false;
                        inftProspect['datebirday']        =  respoService.fechaNacimiento;
                        inftProspect['sexo']              =  respoService.sexo === "HOMBRE" ? "H" : "M";
                        inftProspect['rfc']               =  respoService.curp;
                        inftProspect['claveelector']      =  respoService.claveElector;
            
                        inftProspect['municipyBirday']    =  '';
                        inftProspect['stateBirday']       =  respoService.estadoNacimiento != null || respoService.estadoNacimiento != "null" ? respoService.estadoNacimiento :  "";
                        inftProspect['countryBirday']     =  respoService.paisNacimiento   != null || respoService.paisNacimiento   != "null" ? respoService.paisNacimiento   :  "";

                        setInftProspect((prev) => {
                            return { ...prev, ...inftProspect }
                        });

                    }else{
                        setMessageIne('CURPINCORRECTO');
                    }
                });
            }

            setErrors((prevState) => {
                return { ...prevState, ...errors }
            });
        })
    }

    const Btncontinue = (viewParam) => {
        
        if(processOnboarding.toString() === "documents"){

            if(isEditingView === true){
                setProcessOnboarding(viewParam);  
            }else{

                var banderaPhotos = 0;

                if(isEditingPhotos === true){

                    if((documentsProspect.ifefrenteup === ""  || documentsProspect.ifedetrasup  === "") && (documentsProspect.ifefrente === ""  || documentsProspect.ifedetras  === "") ){

                        if(documentsProspect.ifefrenteup  === "" || documentsProspect.ifefrente === "" ){
                            errors['FIFE'] = 'required';
                            
                        }
            
                        if(documentsProspect.ifedetrasup === "" || documentsProspect.ifedetras  === ""){
                            errors['RIFE'] = 'required';
                        }

                        banderaPhotos = 1;

                    }else{

                        errors['FIFE'] = '';
                        errors['RIFE'] = '';

                        banderaPhotos = 0;

                    }   

                    setErrors((prevState) => {
                        return { ...prevState, ...errors }
                    });

                
                }else{

                    if(documentsProspect.ifefrente === ""  || documentsProspect.ifedetras  === ""){

                        if(documentsProspect.ifefrente  === ""){
                            errors['FIFE'] = 'required';
                            
                        }
            
                        if(documentsProspect.ifedetras === ""){
                            errors['RIFE'] = 'required';
                        }

                        banderaPhotos = 1;

                    }else{

                        errors['FIFE'] = '';
                        errors['RIFE'] = '';

                        banderaPhotos = 0;

                    }   

                    setErrors((prevState) => {
                        return { ...prevState, ...errors }
                    });

                }

                if(banderaPhotos === 0){

                    if(String(params[0]) === "Web"){
    
                        windowLoad("Guardando información.....");

                        var identifier   = isEditingPhotos === true ? uiidState : String(retrieveClave());
                        var photoFrontal = isEditingPhotos === true ?   documentsProspect.ifefrenteup.slice(
                                                                            documentsProspect.ifefrenteup.indexOf("base64") + 7,
                                                                            documentsProspect.ifefrenteup.length
                                                                        ) 
                                                                        :
                                                                        documentsProspect.ifefrente.slice(
                                                                            documentsProspect.ifefrente.indexOf("base64") + 7,
                                                                            documentsProspect.ifefrente.length
                                                                        );
                        var photoReverso = isEditingPhotos === true ?   documentsProspect.ifedetrasup.slice(
                                                                            documentsProspect.ifedetrasup.indexOf("base64") + 7,
                                                                            documentsProspect.ifedetrasup.length
                                                                        ) 
                                                                        :
                                                                        documentsProspect.ifedetras.slice(
                                                                            documentsProspect.ifedetras.indexOf("base64") + 7,
                                                                            documentsProspect.ifedetras.length
                                                                        );
                                                                            
                        var flow_INE_Frontal = isEditingPhotos === true ? 6 : 1;
                        var flow_INE_Revero  = isEditingPhotos === true ? 7 : 2;
                        
                        saveDocumentsClient(
                            "",
                            "",
                            null,
                            flow_INE_Frontal, 
                            photoFrontal, 
                            "", 
                            "",
                            false, 
                            identifier).then(function (respdoc) {
                                
                                if(respdoc === "error"){
                                    closeModal();
                                    errors['documents'] = 'errorSave';
                                    setErrors((prevState) => {
                                        return { ...prevState, ...errors }
                                    });
                                }else{
                                    saveDocumentsClient(
                                        "",
                                        "",
                                        null,
                                        flow_INE_Revero, 
                                        "", 
                                        photoReverso, 
                                        "",  
                                        false, 
                                        identifier).then(function (respdoc) {
                                            closeModal();

                                            if(respdoc === "error"){
                                                errors['documents'] = 'errorSave';
                                                setErrors((prevState) => {
                                                    return { ...prevState, ...errors }
                                                });
                                            }else{

                                                if(documentsProspect.curpbase64 != ""){

                                                    saveDocumentsClient(
                                                        "",
                                                        documentsProspect.curpbase64.slice(
                                                            documentsProspect.curpbase64.indexOf("base64") + 7,
                                                            documentsProspect.curpbase64.length
                                                        ),
                                                        null,
                                                        3, 
                                                        "",
                                                        "",
                                                        "", 
                                                        false, 
                                                        String(retrieveClave())).then(function (respdoc) {
                                                            
                                                            if(respdoc === "error"){
                                                                closeModal();
                                                                errors['documents'] = 'errorSave';
                                                                setErrors((prevState) => {
                                                                    return { ...prevState, ...errors }
                                                                });
                                                            }else{
                                                                setProcessOnboarding(viewParam);
                                                            }
                                                        });
                                                }else{
                                                    setProcessOnboarding(viewParam);
                                                }

                                               
                                            }     
                                    });  
                                }     
                        }); 

                    }else{

                        if(String(params[0]) === "MovilAndroid"){
                            try {
                                window.Android.guardaCache(NUM_VIEW_ANDROID["documents"],BASE_URL_SERVER+url_server[0]+"&documents");
                            }catch (error) { }
                        }
                        setProcessOnboarding(viewParam);  
                    } 
    
                }
            }
            
            

        }else if(processOnboarding.toString() === "general"){

            if( (inftProspect.curp              === "-" ||  inftProspect.curp              === null ||  inftProspect.curp               === "") || 
                (inftProspect.name              === "-" ||  inftProspect.name              === null ||  inftProspect.name               === "") || 
                ((inftProspect.firstname         === "-"||  inftProspect.firstname         === null ||  inftProspect.firstname          === "") && 
                (inftProspect.secondname        === "-" ||  inftProspect.secondname        === null ||  inftProspect.secondname         === "") ) ||
                //(inftProspect.datebirday        === "-" ||  inftProspect.datebirday        === null ||  inftProspect.datebirday         === "") ||
                (inftProspect.sexo              === "-" ||  inftProspect.sexo              === null ||  inftProspect.sexo               === "") ||
                (inftProspect.rfc               === "-" ||  inftProspect.rfc               === null ||  inftProspect.rfc                === "") ||
                (inftProspect.municipyBirday    === "-" ||  inftProspect.municipyBirday    === null ||  inftProspect.municipyBirday     === "") ||
                (inftProspect.stateBirday       === "-" ||  inftProspect.stateBirday       === null ||  inftProspect.stateBirday        === "") ||
                (inftProspect.countryBirday     === "-" ||  inftProspect.countryBirday     === null ||  inftProspect.countryBirday      === "") ||
                (inftProspect.nacionalityBidray === "-" || inftProspect.nacionalityBidray  === null ||  inftProspect.nacionalityBidray  === "") 
                ){
                
                if((inftProspect.curp  === "-" ||  inftProspect.curp  === null ||  inftProspect.curp  === "") ){
                    errors['curp'] = 'required';
                }

                if((inftProspect.name  === "-" ||  inftProspect.name  === null ||  inftProspect.name  === "") ){
                    errors['name'] = 'required';
                }


                if((inftProspect.firstname  === "-" ||  inftProspect.firstname  === null ||  inftProspect.firstname  === "") && (inftProspect.secondname  === "-" ||  inftProspect.secondname  === null ||  inftProspect.secondname  === "") ){
                    errors['firstname']  = 'required';
                    errors['secondname'] = '';
                }else if((inftProspect.secondname  === "-" ||  inftProspect.secondname  === null ||  inftProspect.secondname  === "")  &&  (inftProspect.firstname  === "-" ||  inftProspect.firstname  === null ||  inftProspect.firstname  === "")){
                    errors['firstname']  = '';
                    errors['secondname'] = 'required';
                }else{

                    if((inftProspect.firstname  === "-" ||  inftProspect.firstname  === null ||  inftProspect.firstname  === "") ){
                        errors['firstname'] = 'required';
                    }
    
                    if((inftProspect.secondname  === "-" ||  inftProspect.secondname  === null ||  inftProspect.secondname  === "") && inftProspect.issecondname == false ){
                        errors['secondname'] = 'required';
                    }

                }

                /*if((inftProspect.datebirday  === "-" ||  inftProspect.datebirday  === null ||  inftProspect.datebirday  === "") ){
                    errors['datebirday'] = 'required';
                }*/

                if((inftProspect.sexo  === "-" ||  inftProspect.sexo  === null ||  inftProspect.sexo  === "") ){
                    errors['sexo'] = 'required';
                }

                if((inftProspect.rfc  === "-" ||  inftProspect.rfc  === null ||  inftProspect.rfc  === "") ){
                    errors['rfc'] = 'required';
                }

                if((inftProspect.municipyBirday  === "-" ||  inftProspect.municipyBirday  === null ||  inftProspect.municipyBirday  === "") ){
                    errors['municipyBirday'] = 'required';
                }

                if((inftProspect.stateBirday  === "-" ||  inftProspect.stateBirday  === null ||  inftProspect.stateBirday  === "") ){
                    errors['stateBirday'] = 'required';
                }

                if((inftProspect.countryBirday  === "-" ||  inftProspect.countryBirday  === null ||  inftProspect.countryBirday  === "") ){
                    errors['countryBirday'] = 'required';
                }

                if((inftProspect.nacionalityBidray  === "-" ||  inftProspect.nacionalityBidray  === null ||  inftProspect.nacionalityBidray  === "") ){
                    errors['nacionalityBidray'] = 'required';
                }
                        
                setErrors((prevState) => {
                    return { ...prevState, ...errors }
                });

            }else{

                windowLoad("Guardando información.....");

                var identifier  =  uiidState;

                var sexoClient = inftProspect.sexo === "H" ? "masculino" : "femenino";
                
                saveDataGeneral(
                                identifier,
                                asesoridState, 
                                String(inftProspect.firstname).trim(), 
                                String(inftProspect.secondname).trim(), 
                                String(inftProspect.municipyBirday).trim(), 
                                String(inftProspect.claveelector).trim(), 
                                String(inftProspect.numeroine).trim(),
                                String(inftProspect.curp).trim(), 
                                String(inftProspect.maritalstatus).trim(), 
                                String(inftProspect.stateBirday).trim(), 
                                inftProspect.datebirday === null ? null : String(moment(inftProspect.datebirday,"DD/MM/YYYY").format("YYYY-MM-DD")), 
                                String(inftProspect.name).trim(), 
                                String(inftProspect.curp).substring(0, 10), 
                                String(sexoClient).trim() ).then(function (respSave) {

                            if(respSave.message === "error"){
                                closeModal();
                                errors['serviceServer'] = 'serverError';
                            }else if(respSave.message === "No Data"){
                                closeModal();
                                errors['serviceServer'] = 'noSave';
                            }else if(respSave.message === "Success"){
                                if(String(params[0]) === "MovilAndroid"){
                                    try {
                                        window.Android.guardaCache(NUM_VIEW_ANDROID["general"],BASE_URL_SERVER+url_server[0]+"&general");
                                    }catch (error) { } 
                                }
                                closeModal();
                                setErrors({})
                                setProcessOnboarding(viewParam);
                            }else{
                                closeModal();
                                errors['serviceServer'] = 'serverError';
                            }
                            setErrors((prevState) => {
                                return { ...prevState, ...errors }
                            });
                });
            }

        }else if(processOnboarding.toString() === "imgdoc"){

            if(isEditingView === true){
                setProcessOnboarding(viewParam); 
            }else if(inftProspect.isIFEAdress === true ) {
                windowLoad("Guardando información...");
                
                saveDocumentsClient(
                    documentsProspect.comprobbase64up.slice(
                        documentsProspect.comprobbase64up.indexOf("base64") + 7,
                        documentsProspect.comprobbase64up.length
                    ), 
                    "",
                    asesoridState,
                    5, 
                    "", 
                    "", 
                    "",
                    false, 
                    String(uiidState)).then(function (respdoc) {

                        windowLoad("Finalizando...");

                        if(respdoc === "error"){
                            closeModal();
                            errors['documents'] = 'errorSave';
                            setErrors((prevState) => {
                                return { ...prevState, ...errors }
                            });
                        }else{
                            closeModal();

                            if(String(params[0]) === "MovilAndroid"){
                                try {
                                    window.Android.guardaCache(NUM_VIEW_ANDROID["imgdoc"],BASE_URL_SERVER+url_server[0]+"&imgdoc");
                                }catch (error) { } 
                            }

                            setProcessOnboarding(viewParam); 
                        }     
                }); 

            }else{

                var banderaPhotos = 0;

                if(isEditingPhotos === true){

                    if(documentsProspect.comprobbase64up === "" && documentsProspect.comprobbase64 === ""){

                        errors['DOM'] = "required";
                        setErrors((prevState) => {
                            return { ...prevState, ...errors }
                        });

                        banderaPhotos = 1;

                    }else{

                        errors['DOM'] = "";
                        banderaPhotos = 0;

                    }   

                    setErrors((prevState) => {
                        return { ...prevState, ...errors }
                    });

                }else{

                    if(documentsProspect.comprobbase64 === ""){

                        errors['DOM'] = "required";
                        setErrors((prevState) => {
                            return { ...prevState, ...errors }
                        });

                        banderaPhotos = 1;

                    }else{

                        errors['DOM'] = "";
                        banderaPhotos = 0;

                    }   

                    setErrors((prevState) => {
                        return { ...prevState, ...errors }
                    });

                }

                if(banderaPhotos === 0){
                
                    if(String(params[0]) === "Web"){

                        windowLoad("Guardando información...");

                        var identifier  = isEditingPhotos === true ? uiidState : String(retrieveClave());
                        var photoDoc    = isEditingPhotos === true  ?   documentsProspect.comprobbase64up.slice(
                                                                            documentsProspect.comprobbase64up.indexOf("base64") + 7,
                                                                            documentsProspect.comprobbase64up.length
                                                                        ) 
                                                                        :
                                                                        documentsProspect.comprobbase64.slice(
                                                                            documentsProspect.comprobbase64.indexOf("base64") + 7,
                                                                            documentsProspect.comprobbase64.length
                                                                        );
                        
                        saveDocumentsClient(
                            photoDoc, 
                            "",
                            null,
                            5, 
                            "", 
                            "", 
                            "",
                            false, 
                            identifier).then(function (respdoc) {
                                if(respdoc === "error"){
                                    closeModal();
                                    errors['documents'] = 'errorSave';
                                    setErrors((prevState) => {
                                        return { ...prevState, ...errors }
                                    });
                                }else{
                                    
                                    closeModal();                
                                    setProcessOnboarding(viewParam); 

                                }     
                        }); 

                    }else{
    
                        if(String(params[0]) === "MovilAndroid"){
                            try {
                                window.Android.guardaCache(NUM_VIEW_ANDROID["imgdoc"],BASE_URL_SERVER+url_server[0]+"&imgdoc");
                            }catch (error) { } 
                        }
    
                        closeModal();
                        setProcessOnboarding(viewParam);

                    }

                }
            }
            

        }else if(processOnboarding.toString() === "selfie"){

            if(isEditingView === true){
                setProcessOnboarding(viewParam); 
            }else{

                var banderaPhotos = 0;

                if(isEditingPhotos === true){

                    if(documentsProspect.selfiebase64up === "" && documentsProspect.selfiebase64 === ""){

                        errors['SELFIE'] = "required";
                        setErrors((prevState) => {
                            return { ...prevState, ...errors }
                        });

                        banderaPhotos = 1;

                    }else{

                        errors['SELFIE'] = "";
                        banderaPhotos = 0;

                    }   

                    setErrors((prevState) => {
                        return { ...prevState, ...errors }
                    });

                }else{
                
                    if(documentsProspect.selfiebase64 === ""){

                        errors['SELFIE'] = "required";
                        setErrors((prevState) => {
                            return { ...prevState, ...errors }
                        });

                        banderaPhotos = 1;

                    }else{

                        errors['SELFIE'] = "";
                        banderaPhotos = 0;

                    }   

                    setErrors((prevState) => {
                        return { ...prevState, ...errors }
                    });

                }

                
                if(banderaPhotos === 0){
    
                    if(String(params[0]) === "Web"){

                        windowLoad("Guardando información.....");
                        
                        var identifier  = isEditingPhotos === true ? uiidState : String(retrieveClave());
                        var photoSelfie = isEditingPhotos === true  ?   documentsProspect.selfiebase64up.slice(
                                                                            documentsProspect.selfiebase64up.indexOf("base64") + 7,
                                                                            documentsProspect.selfiebase64up.length
                                                                        ) 
                                                                        :
                                                                        documentsProspect.selfiebase64.slice(
                                                                            documentsProspect.selfiebase64.indexOf("base64") + 7,
                                                                            documentsProspect.selfiebase64.length
                                                                        );
                        
                        saveDocumentsClient(
                            "", 
                            "",
                            null,
                            4, 
                            "", 
                            "", 
                            photoSelfie,
                            false, 
                            identifier).then(function (respdoc) {

                                if(respdoc === "error"){
                                    closeModal();
                                    errors['documents'] = 'errorSave';
                                    setErrors((prevState) => {
                                        return { ...prevState, ...errors }
                                    });
                                }else{
                                    closeModal();
                                    setProgressoRegister(parseInt(progressoRegister)+20);
                                    setProgressoCounter(parseInt(progressoCounter)+1);
                
                                    setProcessOnboarding(viewParam); 
                                }     
                        }); 

                    }else{

                        var photoFrontal = isEditingPhotos === true ?   documentsProspect.ifefrenteup.slice(
                                                                            documentsProspect.ifefrenteup.indexOf("base64") + 7,
                                                                            documentsProspect.ifefrenteup.length
                                                                        ) 
                                                                        :
                                                                        documentsProspect.ifefrente.slice(
                                                                            documentsProspect.ifefrente.indexOf("base64") + 7,
                                                                            documentsProspect.ifefrente.length
                                                                        );
                        var photoReverso = isEditingPhotos === true ?   documentsProspect.ifedetrasup.slice(
                                                                            documentsProspect.ifedetrasup.indexOf("base64") + 7,
                                                                            documentsProspect.ifedetrasup.length
                                                                        ) 
                                                                        :
                                                                        documentsProspect.ifedetras.slice(
                                                                            documentsProspect.ifedetras.indexOf("base64") + 7,
                                                                            documentsProspect.ifedetras.length
                                                                        );
    
                        if(isEditingPhotos === true){

                            setProcessOnboarding(viewParam);
                                                
                            if(String(params[0]) === "MovilAndroid"){
                                try {
                                    window.Android.guardaCache(NUM_VIEW_ANDROID["selfie"],BASE_URL_SERVER+url_server[0]+"&selfie");
                                }catch (error) { } 
                            }
                                                
                        }else if(inftProspect.curpextra === "alterno"){
                            
                            
    
                            var ine_frente = photoFrontal;
                            var ine_detras = photoReverso;
    
                            var curp = inftProspect.curp;
        
                            getSelfInfoDocumentsCurp(ine_frente, ine_detras, uiidState, curp, windowLoad, setModal, inftProspect, setInftProspect, setMessageIne, setErrors, setProcessOnboarding, viewParam, setProgressoRegister, progressoRegister, setProgressoCounter, progressoCounter );
                            
                            if(String(params[0]) === "MovilAndroid"){
                                try {
                                    window.Android.guardaCache(NUM_VIEW_ANDROID["selfie"],BASE_URL_SERVER+url_server[0]+"&selfie");
                                }catch (error) { }
                            }
                            
                        }else{

                            var ine_frente = photoFrontal;
                            var ine_detras = photoReverso;
        
                            getSelfInfoDocuments(ine_frente, ine_detras, uiidState, windowLoad, setModal, inftProspect, setInftProspect, setMessageIne, setErrors, setProcessOnboarding, viewParam, setProgressoRegister, progressoRegister, setProgressoCounter, progressoCounter );
                            
                            if(String(params[0]) === "MovilAndroid"){
                                try {
                                    window.Android.guardaCache(NUM_VIEW_ANDROID["selfie"],BASE_URL_SERVER+url_server[0]+"&selfie");
                                }catch (error) { }
                            }
                            
                        }
                        
                    }
                    
                }
            }

            
        }else if(processOnboarding.toString() === "domicilio"){
           
            if( (inftProspect.street            === "-" ||  inftProspect.street            === null ||  inftProspect.street          === "" ||  inftProspect.street          === " ") || 
                (inftProspect.exterior          === "-" ||  inftProspect.exterior          === null ||  inftProspect.exterior        === "" ||  inftProspect.exterior        === " ") || 
                (inftProspect.codepostal        === "-" ||  inftProspect.codepostal        === null ||  inftProspect.codepostal      === "" ||  inftProspect.codepostal      === " ") || 
                (inftProspect.colonia           === "-" ||  inftProspect.colonia           === null ||  inftProspect.colonia         === "" ||  inftProspect.colonia         === " ") ||
                (inftProspect.municipio         === "-" ||  inftProspect.municipio         === null ||  inftProspect.municipio       === "" ||  inftProspect.municipio       === " ") ||
                (inftProspect.estado            === "-" ||  inftProspect.estado            === null ||  inftProspect.estado          === "" ||  inftProspect.estado          === " ") ||
                (inftProspect.country           === "-" ||  inftProspect.country           === null ||  inftProspect.country         === "" ||  inftProspect.country         === " ")
                ){
                
                if((inftProspect.street  === "-" ||  inftProspect.street  === null ||  inftProspect.street  === "" ||  inftProspect.street  === " ") ){
                    errors['street'] = 'required';
                }

                if((inftProspect.exterior  === "-" ||  inftProspect.exterior  === null ||  inftProspect.exterior  === "" ||  inftProspect.exterior  === " ") ){
                    errors['exterior'] = 'required';
                }

                if((inftProspect.codepostal  === "-" ||  inftProspect.codepostal  === null ||  inftProspect.codepostal  === "" ||  inftProspect.codepostal  === " ") ){
                    errors['codepostal'] = 'required';
                }

                if((inftProspect.colonia  === "-" ||  inftProspect.colonia  === null ||  inftProspect.colonia  === "" ||  inftProspect.colonia  === " ") ){
                    errors['colonia'] = 'required';
                }

                if((inftProspect.municipio  === "-" ||  inftProspect.municipio  === null ||  inftProspect.municipio  === "" ||  inftProspect.municipio  === " ") ){
                    errors['municipio'] = 'required';
                }

                if((inftProspect.estado  === "-" ||  inftProspect.estado  === null ||  inftProspect.estado  === "" ||  inftProspect.estado  === " ") ){
                    errors['estado'] = 'required';
                }

                if((inftProspect.country  === "-" ||  inftProspect.country  === null ||  inftProspect.country  === "" ||  inftProspect.country  === " ") ){
                    errors['country'] = 'required';
                }
                        
                setErrors((prevState) => {
                    return { ...prevState, ...errors }
                });

            }else{
                windowLoad("Guardando información.....");
                /// calculate
                calculateActos(String(uiidState)).then(function (response) {
                    if(response.message == "No Data" || response.message == "error"){
                        saveDataDomicilio(String(uiidState), String(inftProspect.street).trim(), String(inftProspect.codepostal).trim(), String(inftProspect.municipio).trim(), String(inftProspect.colonia).trim(), String(inftProspect.estado).trim(), String(inftProspect.municipio).trim(), String(inftProspect.exterior).trim(), String(inftProspect.interior).trim(), String(inftProspect.country).trim() ).then(function (respSave) {
                            if(respSave.message === "error"){
                                closeModal();
                                errors['serviceServer'] = 'serverError';
                            }else if(respSave.message === "No Data"){
                                closeModal();
                                errors['serviceServer'] = 'noSave';
                            }else if(respSave.message === "Success"){
                                if(String(params[0]) === "MovilAndroid"){
                                    try{
                                        window.Android.guardaCache(NUM_VIEW_ANDROID["domicilio"],BASE_URL_SERVER+url_server[0]+"&domicilio");
                                    }catch(error){}
                                }
                                closeModal();
                                setErrors({})
                                setProcessOnboarding(viewParam);
                            }else{
                                closeModal();
                                errors['serviceServer'] = 'serverError';
                            }
                            setErrors((prevState) => {
                                return { ...prevState, ...errors }
                            });
                        })
                    }else{

                        saveDataDomicilio(String(uiidState), String(inftProspect.street).trim(), String(inftProspect.codepostal).trim(), String(inftProspect.municipio).trim(), String(inftProspect.colonia).trim(), String(inftProspect.estado).trim(), String(inftProspect.municipio).trim(), String(inftProspect.exterior).trim(), String(inftProspect.interior).trim(), String(inftProspect.country).trim() ).then(function (respSave) {
                            if(respSave.message === "error"){
                                closeModal();
                                errors['serviceServer'] = 'serverError';
                            }else if(respSave.message === "No Data"){
                                closeModal();
                                errors['serviceServer'] = 'noSave';
                            }else if(respSave.message === "Success"){
                                if(String(params[0]) === "MovilAndroid"){
                                    try{
                                        window.Android.guardaCache(NUM_VIEW_ANDROID["domicilio"],BASE_URL_SERVER+url_server[0]+"&domicilio");
                                    }catch(error){}
                                }
                                closeModal();
                                setErrors({})
                                setProcessOnboarding(viewParam);
                            }else{
                                closeModal();
                                errors['serviceServer'] = 'serverError';
                            }
                            setErrors((prevState) => {
                                return { ...prevState, ...errors }
                            });
                        });
                        
                    }
                });

            }

        }else if(processOnboarding.toString() === "contact"){

            if( (inftProspect.phonehome === "") && (inftProspect.cellphone === "")
                ||
                (errors.cellphone === "badcellphone" ||
                 errors.phonehome === "badphonehome"  )){

                if((inftProspect.phonehome === "") && (inftProspect.cellphone === "") ){
                    errors['cellphone'] = 'required';
                }else if( (inftProspect.phonehome === "") && !phoneValidation(inftProspect.cellphone)){
                    errors['cellphone'] = 'badcellphone';
                }else if((inftProspect.cellphone === "") & (inftProspect.phonehome === "")){
                    errors['phonehome'] = 'required';
                }else if((inftProspect.cellphone === "") & !phoneValidation(inftProspect.phonehome)){
                    errors['phonehome'] = 'badphonehome';
                }
                
                setErrors((prevState) => {
                    return { ...prevState, ...errors }
                });

            }else{  

                if(inftProspect.email != "" && (emailValidation(inftProspect.email) === false) ){

                    errors['email'] = 'bademail';
                    
                    setErrors((prevState) => {
                        return { ...prevState, ...errors }
                    });

                }else if(inftProspect.phonehome != "" && (!phoneValidationLng(inftProspect.phonehome))){

                    errors['phonehome'] = 'lessphonehome';
                    
                    setErrors((prevState) => {
                        return { ...prevState, ...errors }
                    });

                }else if(inftProspect.cellphone != "" && (!phoneValidationLng(inftProspect.cellphone))){

                    errors['cellphone'] = 'lesscellphone';
                    
                    setErrors((prevState) => {
                        return { ...prevState, ...errors }
                    });

                }/*else if(!codeOTP.validateCode){

                    let paramsWindowAler = {
                        windowLoad: windowLoad,
                        saveModelContact: saveModelContact,
                        params: {
                            uiidState:            uiidState, 
                            viewParam:            viewParam, 
                            params:                params, 
                            url_server:            url_server, 
                            isEditingView:         isEditingView, 
                            inftProspect:          inftProspect, 
                            isVerification:        codeOTP.validateCode,
                            setCodeOTP:            setCodeOTP,
                            errors:                errors, 
                            setErrors:             setErrors, 
                            setProcessOnboarding:  setProcessOnboarding, 
                            closeModal:            closeModal
                        }
                    };

                    windowMessageAlert("No se ha validado el número de teléfono, ¿Estás seguro de continuar?", "Continuar", "Cancelar", paramsWindowAler);

                }*/else{

                    windowLoad("Guardando información...");
                    saveModelContact(uiidState, viewParam, params, url_server, isEditingView, inftProspect, codeOTP.validateCode, setCodeOTP, errors, setErrors, setProcessOnboarding, closeModal);

                }

            }


        }else{
            setProcessOnboarding(viewParam);
        }

    }

    const openCam = (type) => {
        setProcessOnboarding('cam'+type);
        setActiveCam(true);
    }

    const getPersonInf = async (uuidp, view) => {

        windowLoad("Cargando.....");
        
        consultPersonalInf(uuidp).then(function (responseInf) {

            closeModal();

            if(responseInf == "error"){
                windoMessage('No se pudo cargar correctamente la información');
            }else{

                if(responseInf.code === 200){
                    
                    consultFiles(uuidp, id_credito);

                    if(view === "general"){
                        
                        inftProspect['curp']              =  responseInf.response.personalInfo.curp      ? responseInf.response.personalInfo.curp      : "";
                        inftProspect['curpextra']         =  responseInf.response.personalInfo.curp      ? responseInf.response.personalInfo.curp      : "";
                        inftProspect['name']              =  responseInf.response.personalInfo.nombre    != null  || responseInf.response.personalInfo.nombre != "null" ? responseInf.response.personalInfo.nombre    : "";
                        inftProspect['firstname']         =  responseInf.response.personalInfo.apellidoP != null  || responseInf.response.personalInfo.apellidoP != "null" ? responseInf.response.personalInfo.apellidoP : "";
                        inftProspect['isfirstname']       =  responseInf.response.personalInfo.apellidoP === null || responseInf.response.personalInfo.apellidoP === '' ? true : false;
                        inftProspect['secondname']        =  responseInf.response.personalInfo.apellidoM != null  || responseInf.response.personalInfo.apellidoM != "null" ? responseInf.response.personalInfo.apellidoM : "";
                        inftProspect['issecondname']      =  responseInf.response.personalInfo.apellidoM === null || responseInf.response.personalInfo.apellidoM === '' ? true : false;
                        inftProspect['datebirday']        =  responseInf.response.personalInfo.fechaN    ? moment(responseInf.response.personalInfo.fechaN,"DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY") : "";
                        inftProspect['sexo']              =  responseInf.response.personalInfo.genero != null  || responseInf.response.personalInfo.genero != "null" ? responseInf.response.personalInfo.genero : "M" ;
                        inftProspect['rfc']               =  responseInf.response.personalInfo.rfc;
                        inftProspect['claveelector']      =  responseInf.response.personalInfo.claveElector;
                        inftProspect['numeroine']         =  responseInf.response.personalInfo.numeroINE;
                        
                        
                        inftProspect['municipyBirday']    =  responseInf.response.personalInfo.ciudadNac != null  || responseInf.response.personalInfo.ciudadNac != "null" ? responseInf.response.personalInfo.ciudadNac : "";
                        inftProspect['stateBirday']       =  responseInf.response.personalInfo.estadoNac != null  || responseInf.response.personalInfo.estadoNac != "null" ? responseInf.response.personalInfo.estadoNac : "";
                        inftProspect['countryBirday']     =  responseInf.response.personalInfo.paisNac   != null  || responseInf.response.personalInfo.paisNac != "null" ? responseInf.response.personalInfo.paisNac : "";

                        setInftProspect((prev) => {
                            return { ...prev, ...inftProspect }
                        });

                    }else if(view === "domicilio"){

                        inftProspect['street']           =  responseInf.response.adressInfo.calle        != null || responseInf.response.adressInfo.calle        != "null" ? responseInf.response.adressInfo.calle : "" ;
                        inftProspect['exterior']         =  responseInf.response.adressInfo.numExterior  != null || responseInf.response.adressInfo.numExterior  != "null" ? responseInf.response.adressInfo.numExterior  : "";
                        inftProspect['interior']         =  responseInf.response.adressInfo.numInterno   != null || responseInf.response.adressInfo.numInterno   != "null" ? responseInf.response.adressInfo.numInterno   : "";
                        inftProspect['codepostal']       =  responseInf.response.adressInfo.codigoPostal != null || responseInf.response.adressInfo.codigoPostal != "null" ? responseInf.response.adressInfo.codigoPostal : "";
                        inftProspect['colonia']          =  responseInf.response.adressInfo.colonia      != null || responseInf.response.adressInfo.colonia      != "null" ? responseInf.response.adressInfo.colonia      : "";
                        inftProspect['municipio']        =  responseInf.response.adressInfo.municipio    != null || responseInf.response.adressInfo.municipio    != "null" ? responseInf.response.adressInfo.municipio    : "";
                        inftProspect['estado']           =  responseInf.response.adressInfo.estado       != null || responseInf.response.adressInfo.estado       != "null" ? responseInf.response.adressInfo.estado       : "";
                        inftProspect['country']          =  responseInf.response.adressInfo.pais         != null || responseInf.response.adressInfo.pais         != "null" ? responseInf.response.adressInfo.pais         : "";
                        
                        setInftProspect((prev) => {
                            return { ...prev, ...inftProspect }
                        });

                    }else if(view === "contact"){

                        inftProspect['cellphone']         =  responseInf.response.contactInfo.telefonoCelular != null || responseInf.response.contactInfo.telefonoCelular != "null" ? responseInf.response.contactInfo.telefonoCelular : "";
                        inftProspect['phonehome']         =  responseInf.response.contactInfo.telefonoCasa    != null || responseInf.response.contactInfo.telefonoCasa    != "null" ? responseInf.response.contactInfo.telefonoCasa    : "";
                        inftProspect['email']             =  responseInf.response.contactInfo.correo          != null || responseInf.response.contactInfo.correo          != "null" ? responseInf.response.contactInfo.correo          : "";

                        setInftProspect((prev) => {
                            return { ...prev, ...inftProspect }
                        });

                    }else {
                       
                        inftProspect['curp']              =  responseInf.response.personalInfo.curp      ? responseInf.response.personalInfo.curp      : "";
                        inftProspect['curpextra']         =  responseInf.response.personalInfo.curp      ? responseInf.response.personalInfo.curp      : "";
                        inftProspect['name']              =  responseInf.response.personalInfo.nombre    != null  || responseInf.response.personalInfo.nombre != "null" ? responseInf.response.personalInfo.nombre    : "";
                        inftProspect['firstname']         =  responseInf.response.personalInfo.apellidoP != null  || responseInf.response.personalInfo.apellidoP != "null" ? responseInf.response.personalInfo.apellidoP : "";
                        inftProspect['isfirstname']       =  responseInf.response.personalInfo.apellidoP === null || responseInf.response.personalInfo.apellidoP === '' ? true : false;
                        inftProspect['secondname']        =  responseInf.response.personalInfo.apellidoM != null  || responseInf.response.personalInfo.apellidoM != "null" ? responseInf.response.personalInfo.apellidoM : "";
                        inftProspect['issecondname']      =  responseInf.response.personalInfo.apellidoM === null || responseInf.response.personalInfo.apellidoM === '' ? true : false;
                        inftProspect['datebirday']        =  responseInf.response.personalInfo.fechaN    ? moment(responseInf.response.personalInfo.fechaN,"DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY") : "";
                        inftProspect['sexo']              =  responseInf.response.personalInfo.genero != null  || responseInf.response.personalInfo.genero != "null" ? responseInf.response.personalInfo.genero : "M" ;
                        inftProspect['rfc']               =  responseInf.response.personalInfo.rfc;
                        inftProspect['claveelector']      =  responseInf.response.personalInfo.claveElector;
                        inftProspect['numeroine']         =  responseInf.response.personalInfo.numeroINE;
                        
                        
                        inftProspect['municipyBirday']    =  responseInf.response.personalInfo.ciudadNac != null  || responseInf.response.personalInfo.ciudadNac != "null" ? responseInf.response.personalInfo.ciudadNac : "";
                        inftProspect['stateBirday']       =  responseInf.response.personalInfo.estadoNac != null  || responseInf.response.personalInfo.estadoNac != "null" ? responseInf.response.personalInfo.estadoNac : "";
                        inftProspect['countryBirday']     =  responseInf.response.personalInfo.paisNac   != null  || responseInf.response.personalInfo.paisNac != "null" ? responseInf.response.personalInfo.paisNac : "";

                        inftProspect['street']            =  responseInf.response.adressInfo.calle        != null || responseInf.response.adressInfo.calle        != "null" ? responseInf.response.adressInfo.calle : "" ;
                        inftProspect['exterior']          =  responseInf.response.adressInfo.numExterior  != null || responseInf.response.adressInfo.numExterior  != "null" ? responseInf.response.adressInfo.numExterior  : "";
                        inftProspect['interior']          =  responseInf.response.adressInfo.numInterno   != null || responseInf.response.adressInfo.numInterno   != "null" ? responseInf.response.adressInfo.numInterno   : "";
                        inftProspect['codepostal']        =  responseInf.response.adressInfo.codigoPostal != null || responseInf.response.adressInfo.codigoPostal != "null" ? responseInf.response.adressInfo.codigoPostal : "";
                        inftProspect['colonia']           =  responseInf.response.adressInfo.colonia      != null || responseInf.response.adressInfo.colonia      != "null" ? responseInf.response.adressInfo.colonia      : "";
                        inftProspect['municipio']         =  responseInf.response.adressInfo.municipio    != null || responseInf.response.adressInfo.municipio    != "null" ? responseInf.response.adressInfo.municipio    : "";
                        inftProspect['estado']            =  responseInf.response.adressInfo.estado       != null || responseInf.response.adressInfo.estado       != "null" ? responseInf.response.adressInfo.estado       : "";
                        inftProspect['country']           =  responseInf.response.adressInfo.pais         != null || responseInf.response.adressInfo.pais         != "null" ? responseInf.response.adressInfo.pais         : "";
                        
                        inftProspect['cellphone']         =  responseInf.response.contactInfo.telefonoCelular != null || responseInf.response.contactInfo.telefonoCelular != "null" ? responseInf.response.contactInfo.telefonoCelular : "";
                        inftProspect['phonehome']         =  responseInf.response.contactInfo.telefonoCasa    != null || responseInf.response.contactInfo.telefonoCasa    != "null" ? responseInf.response.contactInfo.telefonoCasa    : "";
                        inftProspect['email']             =  responseInf.response.contactInfo.correo          != null || responseInf.response.contactInfo.correo          != "null" ? responseInf.response.contactInfo.correo          : "";

                        setInftProspect((prev) => {
                            return { ...prev, ...inftProspect }
                        });

                    }

                } 

            }
            
        });

    }

    const consultFilesUp = (uuid, creditoid, type) => {

        windowLoad("Consultando información.....");
        getFiles(String(uuid), creditoid).then(function (response) {

            if(response.toString() === "error"){
                closeModal();
                windoMessage('No se pudo cargar correctamente la información');
            }else{
                if(type === "selfie" || type === "general"){

                    if(type === "selfie"){
                        
                        if(response.response.selfie != null){
                            getBase64FromUrl(response.response.selfie).then((img) => {
                                closeModal();
                                documentsProspect['selfiebase64']   = img; 
                                setDocumentsProspect((prev) => {
                                    return { ...prev, ...documentsProspect }
                                });
                            });

                            imageToFile(response.response.selfie).then((img) => {
                                closeModal();
                                documentsProspect['selfiefile']   = img;
                                setDocumentsProspect((prev) => {
                                    return { ...prev, ...documentsProspect }
                                });
                            });
                            //documentsProspect['selfiebase64']   = response.response.selfie; 
                        }

                        /*setDocumentsProspect((prev) => {
                            return { ...prev, ...documentsProspect }
                        });*/

                    }

                    /*var ine_frente = response.response.ineAnverso.slice(
                        response.response.ineAnverso.indexOf("base64") + 7,
                        response.response.ineAnverso.length
                    );

                    var ine_detras = response.response.ineReverso.slice(
                        response.response.ineReverso.indexOf("base64") + 7,
                        response.response.ineReverso.length
                    );*/

                    getBase64FromUrl(response.response.ineAnverso).then((img) => {
                        closeModal();
                        documentsProspect['ifefrente']   = img;
                        setDocumentsProspect((prev) => {
                            return { ...prev, ...documentsProspect }
                        });
                    });

                    getBase64FromUrl(response.response.ineReverso).then((img) => {
                        closeModal();
                        documentsProspect['ifedetras']   = img;
                        setDocumentsProspect((prev) => {
                            return { ...prev, ...documentsProspect }
                        });
                    });
                        
                    getUpInfoDocuments(documentsProspect.ifefrente, documentsProspect.ifedetras, uiidState, windowLoad, setModal, inftProspect, setInftProspect, setMessageIne, setErrors, setProcessOnboarding, type, setProgressoRegister, progressoRegister, setProgressoCounter, progressoCounter );


                }else if(type === "imgdoc"){

                    closeModal();

                    setProcessOnboarding("imgdoc");


                    if(response.response.comprobante != null){

                        if(response.response.isIneAdress === true){
                            getPersonInf(uuid, "domicilio");

                            getBase64FromUrl(response.response.comprobante).then((img) => {
                                documentsProspect['comprobbase64up'] = img;
                                documentsProspect['comprobbase64'] = img; 
                                setDocumentsProspect((prev) => {
                                    return { ...prev, ...documentsProspect }
                                });
                            });

                            //documentsProspect['comprobbase64up'] = response.response.comprobante;
                        }else{
                            getPersonInf(uuid, "domicilio");

                            getBase64FromUrl(response.response.comprobante).then((img) => {
                                documentsProspect['comprobbase64'] = img; 
                                setDocumentsProspect((prev) => {
                                    return { ...prev, ...documentsProspect }
                                });
                            });
                            //documentsProspect['comprobbase64']   = response.response.comprobante;
                        }
                        
                    }

                    /*setDocumentsProspect((prev) => {
                        return { ...prev, ...documentsProspect }
                    });*/

                }else{
                    closeModal();
                    setProcessOnboarding("contact");
                }
            }

        });
    }

    const consultDocuments = (uuid) => {
        
        consultInformationC(String(uuid),0).then(function (response) {
            if(response.toString() === "error"){
                closeModal();
                windoMessage('No se pudo cargar correctamente la información');
            }else{

                setUiidState(uuid);

                if(response.filesd.code === 200){

                    if(response.filesd.response.ineAnverso !=  null){
                        getBase64FromUrl(response.filesd.response.ineAnverso).then((img) => {
                            closeModal();
                            documentsProspect['ifefrenteup']   = img;
                            setDocumentsProspect((prev) => {
                                return { ...prev, ...documentsProspect }
                            });
                        });
                        //documentsProspect['ifefrenteup']   = response.filesd.response.ineAnverso;
                    }
        
                    if(response.filesd.response.ineReverso != null){
                        getBase64FromUrl(response.filesd.response.ineReverso).then((img) => {
                            closeModal();
                            documentsProspect['ifedetrasup']   = img;
                            setDocumentsProspect((prev) => {
                                return { ...prev, ...documentsProspect }
                            });
                        });
                        //documentsProspect['ifedetrasup']   = response.filesd.response.ineReverso;
                    }
        
                    if(response.filesd.response.selfie != null){
                        getBase64FromUrl(response.filesd.response.selfie).then((img) => {
                            closeModal();
                            documentsProspect['selfiebase64up']   = img;
                            setDocumentsProspect((prev) => {
                                return { ...prev, ...documentsProspect }
                            });
                        });

                        imageToFile(response.filesd.response.selfie).then((img) => {
                            closeModal();
                            documentsProspect['selfiefile']   = img;
                            setDocumentsProspect((prev) => {
                                return { ...prev, ...documentsProspect }
                            });
                        });
                        //documentsProspect['selfiebase64up'] = response.filesd.response.selfie; 
                        if(response.filesd.response.infoCurp != null){
                            
                            inftProspect['curp']        = String(response.filesd.response.infoCurp );
                            inftProspect['curpextra']   = "alterno";
        
                            setInftProspect((prev) => {
                                return { ...prev, ...inftProspect }
                            });
                        }
                    }
                    
                    if(response.filesd.response.comprobante != null){
                        getBase64FromUrl(response.filesd.response.comprobante).then((img) => {
                            documentsProspect['comprobbase64up']   = img;
                            setDocumentsProspect((prev) => {
                                return { ...prev, ...documentsProspect }
                            });
                        });
                        //documentsProspect['comprobbase64up']  = response.filesd.response.comprobante;
                    }
        
                    setDocumentsProspect((prev) => {
                        return { ...prev, ...documentsProspect }
                    });

                    if(response.infd.code === 200){

                        inftProspect['curp']              =  response.infd.response.personalInfo.curp      ? response.infd.response.personalInfo.curp      : "";
                        inftProspect['curpextra']         =  response.infd.response.personalInfo.curp      ? response.infd.response.personalInfo.curp      : "";
                        inftProspect['name']              =  response.infd.response.personalInfo.nombre    != null  || response.infd.response.personalInfo.nombre != "null" ? response.infd.response.personalInfo.nombre    : "";
                        inftProspect['firstname']         =  response.infd.response.personalInfo.apellidoP != null  || response.infd.response.personalInfo.apellidoP != "null" ? response.infd.response.personalInfo.apellidoP : "";
                        inftProspect['isfirstname']       =  response.infd.response.personalInfo.apellidoP === null || response.infd.response.personalInfo.apellidoP === '' ? true : false;
                        inftProspect['secondname']        =  response.infd.response.personalInfo.apellidoM != null  || response.infd.response.personalInfo.apellidoM != "null" ? response.infd.response.personalInfo.apellidoM : "";
                        inftProspect['issecondname']      =  response.infd.response.personalInfo.apellidoM === null || response.infd.response.personalInfo.apellidoM === '' ? true : false;
                        inftProspect['datebirday']        =  response.infd.response.personalInfo.fechaN    ? moment(response.infd.response.personalInfo.fechaN,"DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY") : "";
                        inftProspect['sexo']              =  response.infd.response.personalInfo.genero != null  || response.infd.response.personalInfo.genero != "null" ? response.infd.response.personalInfo.genero : "M" ;
                        inftProspect['maritalstatus']     =  response.infd.response.personalInfo.estadoCivil != null  || response.infd.response.personalInfo.estadoCivil != "null" ? response.infd.response.personalInfo.estadoCivil : "soltero" ;
                        inftProspect['rfc']               =  response.infd.response.personalInfo.rfc;
                        inftProspect['claveelector']      =  response.infd.response.personalInfo.claveElector;
                        inftProspect['numeroine']         =  response.infd.response.personalInfo.numeroINE;
                    
                        inftProspect['municipyBirday']    =  response.infd.response.personalInfo.ciudadNac != null  || response.infd.response.personalInfo.ciudadNac != "null" ? response.infd.response.personalInfo.ciudadNac : "";
                        inftProspect['stateBirday']       =  response.infd.response.personalInfo.estadoNac != null  || response.infd.response.personalInfo.estadoNac != "null" ? response.infd.response.personalInfo.estadoNac : "";
                        inftProspect['countryBirday']     =  response.infd.response.personalInfo.paisNac   != null  || response.infd.response.personalInfo.paisNac != "null" ? response.infd.response.personalInfo.paisNac : "";

                        inftProspect['street']            =  response.infd.response.adressInfo.calle        != null || response.infd.response.adressInfo.calle        != "null" ? response.infd.response.adressInfo.calle : "" ;
                        inftProspect['exterior']          =  response.infd.response.adressInfo.numExterior  != null || response.infd.response.adressInfo.numExterior  != "null" ? response.infd.response.adressInfo.numExterior  : "";
                        inftProspect['interior']          =  response.infd.response.adressInfo.numInterno   != null || response.infd.response.adressInfo.numInterno   != "null" ? response.infd.response.adressInfo.numInterno   : "";
                        inftProspect['codepostal']        =  response.infd.response.adressInfo.codigoPostal != null || response.infd.response.adressInfo.codigoPostal != "null" ? response.infd.response.adressInfo.codigoPostal : "";
                        inftProspect['colonia']           =  response.infd.response.adressInfo.colonia      != null || response.infd.response.adressInfo.colonia      != "null" ? response.infd.response.adressInfo.colonia      : "";
                        inftProspect['municipio']         =  response.infd.response.adressInfo.municipio    != null || response.infd.response.adressInfo.municipio    != "null" ? response.infd.response.adressInfo.municipio    : "";
                        inftProspect['estado']            =  response.infd.response.adressInfo.estado       != null || response.infd.response.adressInfo.estado       != "null" ? response.infd.response.adressInfo.estado       : "";
                        inftProspect['country']           =  response.infd.response.adressInfo.pais         != null || response.infd.response.adressInfo.pais         != "null" ? response.infd.response.adressInfo.pais         : "";
                        
                        inftProspect['cellphone']         =  response.infd.response.contactInfo.telefonoCelular != null || response.infd.response.contactInfo.telefonoCelular != "null" ? response.infd.response.contactInfo.telefonoCelular : "";
                        inftProspect['phonehome']         =  response.infd.response.contactInfo.telefonoCasa    != null || response.infd.response.contactInfo.telefonoCasa    != "null" ? response.infd.response.contactInfo.telefonoCasa    : "";
                        inftProspect['email']             =  response.infd.response.contactInfo.correo          != null || response.infd.response.contactInfo.correo          != "null" ? response.infd.response.contactInfo.correo          : "";
                        
                        getByCodePostal(response.infd.response.adressInfo.codigoPostal);

                        setInftProspect((prev) => {
                            return { ...prev, ...inftProspect }
                        });

                    }else{
                        closeModal();
                        windoMessage('No se pudo obtener la información Personal del cliente'); 
                    }
        
                }else{
                    closeModal();
                    windoMessage('No se encontraron imagenes para este cliente'); 
                }

                

            }
        });


    }

    const getByCodePostal = async (codePostal) => {

        windowLoad("Finalizando...");

        var neigboorhodArray = []

        consultByCodePostal(String(codePostal).trim()).then(function (responseCP) {
            closeModal();
            if(responseCP === "error"){
                inftProspect['codepostal'] =  String(codePostal).trim();
            }else{
                for (var i = 0; i < responseCP.length; i++) {
                    
                    neigboorhodArray.push({
                        label: responseCP[i].asentamiento,
                        value: responseCP[i].asentamiento,
                        isDisabled: false,
                    });

                }

                setOpColonias(neigboorhodArray);
                
            }

            setInftProspect((prev) => {
                return { ...prev, ...inftProspect }
            });

        });

    }

    const getCatalogStates = async () => {

        var codePostal = inftProspect.codepostal != "-" || inftProspect.codepostal != "" ? "0" : inftProspect.codepostal; 

        consultStates(codePostal).then(function (response) {
            if(response.toString() != "error"){
                setCatalogStates(response);
            }
        });
    }

    const consultFiles = (uuid, creditoid) => {
        windowLoad("Cargando.....");
        getFiles(String(uuid), creditoid).then(function (response) {

            if(response.toString() === "error"){
                closeModal();
                windoMessage('No se pudo cargar correctamente la información');
            }else{

                
                if(response.code === 200 || response.code === 1003){

                    setUiidState(uuid);

                    if(response.response.ineAnverso !=  null){

                        getBase64FromUrl(response.response.ineAnverso).then((img) => {
                            closeModal();
                            documentsProspect['ifefrente']    = img;
                            setDocumentsProspect((prev) => {
                                return { ...prev, ...documentsProspect }
                            });
                        });
                        //documentsProspect['ifefrente']    = response.response.ineAnverso;
                    }

                    if(response.response.ineReverso != null){

                        getBase64FromUrl(response.response.ineReverso).then((img) => {
                            closeModal();
                            documentsProspect['ifedetras']    = img;
                            setDocumentsProspect((prev) => {
                                return { ...prev, ...documentsProspect }
                            });
                        });

                        //documentsProspect['ifedetras']    = response.response.ineReverso;
                    }
                    
                    if(response.response.curp != null){

                        getBase64FromUrl(response.response.curp).then((img) => {
                            closeModal();
                            documentsProspect['curpbase64']   = img;
                            setDocumentsProspect((prev) => {
                                return { ...prev, ...documentsProspect }
                            });
                        });

                        //documentsProspect['curpbase64']   = response.response.curp;
                        getInformationCURP(uuid);
                    }

                    if(response.response.selfie != null){
                        setDataVigence(response.response.vigence === null ? true : response.response.vigence );
                        //documentsProspect['selfiebase64']   = response.response.selfie; 
                        
                        getBase64FromUrl(response.response.selfie).then((img) => {
                            closeModal();
                            documentsProspect['selfiebase64']   = img; 
                            setDocumentsProspect((prev) => {
                                return { ...prev, ...documentsProspect }
                            });
                        });

                        imageToFile(response.response.selfie).then((img) => {
                            closeModal();
                            documentsProspect['selfiefile']   = img;
                            setDocumentsProspect((prev) => {
                                return { ...prev, ...documentsProspect }
                            });
                        });

                        if(response.response.infoCurp != null){
                            
                            inftProspect['curp']        = String(response.response.infoCurp );
                            inftProspect['curpextra']   = "alterno";

                            setInftProspect((prev) => {
                                return { ...prev, ...inftProspect }
                            });
                        }
                    }

                    if(response.response.comprobante != null){
                        getBase64FromUrl(response.response.comprobante).then((img) => {
                            closeModal();
                            documentsProspect['comprobbase64']   = img; 
                            setDocumentsProspect((prev) => {
                                return { ...prev, ...documentsProspect }
                            });
                        });
                        //documentsProspect['comprobbase64']   = response.response.comprobante;
                    }

                    /*setDocumentsProspect((prev) => {
                        return { ...prev, ...documentsProspect }
                    });*/
                    

                }else{
                    closeModal();
                    windoMessage('No se encontraron imagenes de la solicitud realizada');
                }
            }
            
        });

        
    }  

    const consulFilesCURP = (uuid) => {
        windowLoad("Cargando.....");
        getFiles(String(uuid),0).then(function (response) {

            if(response.toString() === "error"){
                closeModal();
                windoMessage('No se pudo cargar correctamente la información');
            }else{

                closeModal();
                if(response.code === 200 || response.code === 1003){
                    setUiidState(uuid);

                    if(response.response.ineAnverso !=  null){
                        getBase64FromUrl(response.response.ineAnverso).then((img) => {
                            documentsProspect['ifefrente']    = img;
                            setDocumentsProspect((prev) => {
                                return { ...prev, ...documentsProspect }
                            });
                        });
                        //documentsProspect['ifefrente']    = response.response.ineAnverso;
                    }

                    if(response.response.ineReverso != null){
                        getBase64FromUrl(response.response.ineReverso).then((img) => {
                            documentsProspect['ifedetras']    = img;
                            setDocumentsProspect((prev) => {
                                return { ...prev, ...documentsProspect }
                            });
                        });
                        //documentsProspect['ifedetras']    = response.response.ineReverso;
                    }

                    if(response.response.curp != null){
                        getBase64FromUrl(response.response.curp).then((img) => {
                            documentsProspect['curpbase64']   = img;
                            setDocumentsProspect((prev) => {
                                return { ...prev, ...documentsProspect }
                            });
                        });
                        //documentsProspect['curpbase64']   = response.response.curp;
                        getInformationCURP(uuid);
                    }

                    /*setDocumentsProspect((prev) => {
                        return { ...prev, ...documentsProspect }
                    });*/


                }else{
                    closeModal();
                    windoMessage('No se encontraron imagenes de la solicitud realizada');
                }
            }
            
        })
    }

    const selectedViewRecomendations = (viewp) => {
        setViewRecomendation(viewp);
        setProcessOnboarding('recomendations');
    }

    const clearCacheData = () => {
        caches.keys().then((names) => {
          names.forEach((name) => {
            caches.delete(name);
          });
        });
    };

    const clearCacheMovil = () => {
        if(String(params[0]) === "MovilAndroid"){
            try {
                window.Android.deleteCache();
            }catch (error) { }
        }
    }

    const updateCodeOTP = (numberCode, isValidate) => {
        
        codeOTP['numberCode']   = numberCode;
        codeOTP['validateCode'] = isValidate;

        setCodeOTP((prev) => {
            return { ...prev, ...codeOTP }
        });
    };

    useEffect(() => {

        clearCacheData();
        clearCacheMovil();

        if(uiidState === null){

            if(params[2] != undefined){
                setUiidState(params[2]);
            }else{
                consultUiid()
            }
            
        }

        if(params[1] != undefined){
            setIsEditingView(false);
            setIsEditingPhotos(false);
            setProcessOnboarding(params[1]);
            setTypeViewMovil(params[0]);

            setAsesoridState(id_employe);
            setCreditoidState(id_credito);
    
        }

        if(String(params[1]) === "general" || String(params[1]) === "domicilio" || String(params[1]) === "contact"){     
            getPersonInf(String(params[2]), String(params[1]));
            if(String(params[1]) === "domicilio"){
                if(inftProspect.codepostal){
                    getCatalogStates();
                }
            }
        }else if(String(params[1]) === "edit"){
            setIsEditingView(false);
            setIsEditingPhotos(false);
            getCalculateAct(String(params[2]));
            getCatalogStates();
        }else if(String(params[1]) === "editClient"){
            setIsEditingView(true);
            setIsEditingPhotos(false);
            getCalculateEdit(String(params[2]));
            getCatalogStates();
        }else if(String(params[1]) === "creditClient"){
            setIsEditingView(false);
            setIsEditingPhotos(true);
            getCalculateCredit(String(params[2]), id_credito, "");
        }else if(id_view === "creditClient"){
            setIsEditingView(false);
            setIsEditingPhotos(true);
            getCalculateCredit(String(params[2]), id_credito, String(params[1]));
        }else{
    
            setIsEditingView(false); 
            setIsEditingPhotos(false);
            if(params[3] != undefined || params[4] != undefined || params[5] != undefined){

                if(params[5] != undefined){
                    
                    consulFilesCURP(params[2]);

                    setMessageIne("MovilCurp");
                    setSeeCURP(true);
                    setShowIMGCURP(true);

                }else{
                    consultFiles(params[2], id_credito );
                }
            }
            
        }

        
        

    }, []);

    return(
        <div>
            {
                String(processOnboarding).toString() === "selfie" && dataVigence === false ?
                    <nav class="navbar h-auto fixed-top navbar-light bg-valladolid mt-12">
                        <a class="text-16 text-white" href="#">
                            Verifica que la INE/IFE tenga una vigencia  válida o no cuente con trámites posteriores.
                        </a>  
                    </nav>
                :
                ''
            }
            {
                processOnboarding.toString() === "documents"  ?
                    <Documents 
                        params={params}
                        dataVigence={dataVigence}
                        setDataVigence={setDataVigence}
                        uiid={uiidState}
                        asesoridState={asesoridState}
                        messageIne={messageIne}
                        setMessageIne={setMessageIne}
                        setModal={setModal} 
                        errors={errors} 
                        setErrors={setErrors} 
                        selectedViewRecomendations={selectedViewRecomendations}
                        setProcessOnboarding={setProcessOnboarding}
                        documentsProspect={documentsProspect}
                        setDocumentsProspect={setDocumentsProspect}
                        inftProspect={inftProspect}
                        setInftProspect={setInftProspect}
                        setTypeDocument={setTypeDocument}
                        errorServices={errorServices}
                        setErrorServices={setErrorServices}
                        loadWindowS={loadWindowS}
                        setLoadWindowS={setLoadWindowS}
                        seeCURP={seeCURP}
                        setSeeCURP={setSeeCURP}
                        showIMGCURP={showIMGCURP} 
                        setShowIMGCURP={setShowIMGCURP}
                        isEditingPhotos={isEditingPhotos}
                        setIsBackView={setIsBackView}
                        isBackView={isBackView}
                        setItSameDocument={setItSameDocument}
                        actionbtn={Btncontinue}
                    />
                :
                processOnboarding.toString() === "SuccesMSJ" ?
                    <MSJSucess 
                        setProcessOnboarding={setProcessOnboarding}
                        seeCURP={seeCURP}
                        setSeeCURP={setSeeCURP}
                        showIMGCURP={showIMGCURP}
                        setShowIMGCURP={setShowIMGCURP}
                        typeDocument={typeDocument}
                    />
                :
                processOnboarding.toString() === "selfie" ?
                        <Selfie
                            btnBack={btnBack}
                            params={params}
                            dataVigence={dataVigence}
                            messageSelfie={messageSelfie}
                            setMessageSelfie={setMessageSelfie}
                            uiid={uiidState}
                            asesoridState={id_employe}
                            setModal={setModal} 
                            errors={errors}
                            setErrors={setErrors}
                            setLaunchServe={setLaunchServe}
                            selectedViewRecomendations={selectedViewRecomendations}
                            setProcessOnboarding={setProcessOnboarding}
                            inftProspect={inftProspect}
                            documentsProspect={documentsProspect}
                            setDocumentsProspect={setDocumentsProspect}
                            setTypeDocument={setTypeDocument}
                            isEditingPhotos={isEditingPhotos}
                            setIsBackView={setIsBackView}
                            isBackView={isBackView}
                            actionbtn={Btncontinue}
                    />
                :
                processOnboarding.toString() === "general" ?
                    <General 
                        btnBack={btnBack}
                        setModal={setModal} 
                        dataVigence={dataVigence}
                        errors={errors} 
                        setErrors={setErrors} 
                        setProcessOnboarding={setProcessOnboarding}
                        asesoridState={asesoridState}
                        inftProspect={inftProspect}
                        setInftProspect={setInftProspect}
                        setIsBackView={setIsBackView}
                        actionbtn={Btncontinue}
                    />
                :
                processOnboarding.toString() === "imgdoc" ?
                    <IMGDoc 
                        btnBack={btnBack}
                        params={params}
                        uiid={uiidState}
                        setModal={setModal} 
                        errors={errors} 
                        setErrors={setErrors} 
                        selectedViewRecomendations={selectedViewRecomendations}
                        setProcessOnboarding={setProcessOnboarding}
                        documentsProspect={documentsProspect}
                        setDocumentsProspect={setDocumentsProspect}
                        inftProspect={inftProspect}
                        setInftProspect={setInftProspect}
                        setTypeDocument={setTypeDocument}
                        loadWindowS={loadWindowS}
                        isEditingPhotos={isEditingPhotos}
                        setIsBackView={setIsBackView}
                        isBackView={isBackView}
                        windoMessage={windoMessage}
                        isEditable={isEditable}
                        setIsEditable={setIsEditable}
                        setCatalogStates={setCatalogStates}
                        actionbtn={Btncontinue}
                    />
                :
                
                processOnboarding.toString() === "domicilio" ?
                    <Domicilio 
                        setModal={setModal} 
                        errors={errors}
                        setErrors={setErrors} 
                        setProcessOnboarding={setProcessOnboarding}
                        inftProspect={inftProspect}
                        setInftProspect={setInftProspect}
                        opColonias={opColonias}
                        opStates={catalogStates}
                        setOpColonias={setOpColonias}
                        setIsBackView={setIsBackView}
                        isEditable={isEditable}
                        actionbtn={Btncontinue}
                    />
                :
                processOnboarding.toString() === "contact" ?
                    <Contact 
                        btnBack={btnBack}
                        setModal={setModal} 
                        errors={errors} 
                        setErrors={setErrors}
                        setProcessOnboarding={setProcessOnboarding}
                        inftProspect={inftProspect}
                        setInftProspect={setInftProspect}
                        setProgressoRegister={setProgressoRegister}
                        progressoRegister={progressoRegister}
                        setProgressoCounter={setProgressoCounter}
                        progressoCounter={progressoCounter}
                        setIsBackView={setIsBackView}
                        setTypeDocument={setTypeDocument}
                        actionbtn={Btncontinue}
                        props={{
                            elements: {
                                codeOTP: codeOTP
                            }, 
                            setElements: {
                                setProcessOnboarding: setProcessOnboarding
                            },
                            events: {
                                updateCodeOTP: updateCodeOTP,
                                windowLoad: windowLoad,
                                closeModal: closeModal,
                                windoMessage: windoMessage
                            }
                        }}
                    />
                :
                processOnboarding.toString() === "OTP" ?
                    <OTPView 
                        props={{
                            elements: {
                                inftProspect: inftProspect, 
                                codeOTP: codeOTP,
                                errors: errors
                            }, 
                            setElements: {
                                setProcessOnboarding: setProcessOnboarding,
                                setErrors: setErrors
                            },
                            events:{
                                updateCodeOTP: updateCodeOTP,
                                windowLoad: windowLoad,
                                closeModal: closeModal,
                                windoMessage: windoMessage
                            }
                        }}
                    />
                :
                processOnboarding.toString() === "finish" ?
                    <FinishS 
                        params={params}
                        isEditingView={isEditingView}
                        isEditingPhotos={isEditingPhotos}
                    />
                :
                processOnboarding.toString() === "recomendations" ?
                    <Recomendations  />
                :
                processOnboarding.toString() === "manFINE"  ||  
                processOnboarding.toString() === "manRINE"  || 
                processOnboarding.toString() === "manDOMC"  || 
                processOnboarding.toString() === 'manDCURP' || 
                processOnboarding.toString() === 'manDSELFIE' ?
                    <NotaDocument
                        processOnboarding={processOnboarding}
                        typeDocument={typeDocument}
                        eventc={openCam}
                    />
                :
                processOnboarding.toString() === "camFINE"  ||  
                processOnboarding.toString() === "camRINE"  || 
                processOnboarding.toString() === "camDOMC"  || 
                processOnboarding.toString() === "camDCURP" || 
                processOnboarding.toString() === 'camDSELFIE'?
                    <PhotoMovil 
                        errors={errors} 
                        setLaunchServe={setLaunchServe}
                        setErrors={setErrors} 
                        setProcessOnboarding={setProcessOnboarding}
                        processOnboarding={processOnboarding}
                        documentsProspect={documentsProspect}
                        setDocumentsProspect={setDocumentsProspect}
                        typeDocument={typeDocument}
                        activeCam={activeCam}
                    />
                :
                processOnboarding.toString() === "loadDocument" ?
                    <LoadDocument 
                        setProcessOnboarding={setProcessOnboarding}
                    />
                :
                processOnboarding.toString() === "loadMovil" ?
                    <LoadMovil 
                        setProcessOnboarding={setProcessOnboarding}
                    />
                :
                    <div></div>
            }
        </div>
    )

}
export default WrapperConsumer(Onboarding)